import React from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';

// The old Function Words and Linguistic Notes pages now live as sections of
// /admin/grammar-rules. This keeps their URLs working (and lets a future
// "Rule" link pass ?word= through) instead of breaking bookmarks outright.
export const RedirectToGrammarRules: React.FC<{ section: 'words' | 'notes' }> = ({ section }) => {
  const [searchParams] = useSearchParams();
  const word = searchParams.get('word');
  const params = new URLSearchParams({ section, ...(word ? { word } : {}) });
  return <Navigate to={`/admin/grammar-rules?${params.toString()}`} replace />;
};
